import React from 'react'
import { Label as LabelComponent } from './LabelStyle'

export interface iLabel {
    htmlFor?: string;
    name?: string;
    secondName?: string;
    className?: string;
    border?: boolean;
}

const Label: React.FC<iLabel> = ({ htmlFor, name, secondName, className, children, border }) => (
    <LabelComponent className={className} htmlFor={htmlFor} border={border}>
        {name || children}
        <span> {secondName} </span>
    </LabelComponent>
)

export default Label